const {ccclass, property} = cc._decorator;

@ccclass
export default class widgetNode extends cc.Component {

 

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.node.setPosition(cc.v2(this.node.position.x,this.node.position.y+(cc.winSize.height-1334)/2))
    }

    // update (dt) {}
}
